__turbopack_context__.v({
  "chips": "ClothingSizeRefinement-module-scss-module__gqZVRq__chips",
  "group": "ClothingSizeRefinement-module-scss-module__gqZVRq__group",
  "groupTitle": "ClothingSizeRefinement-module-scss-module__gqZVRq__groupTitle",
  "root": "ClothingSizeRefinement-module-scss-module__gqZVRq__root",
  "showMore": "ClothingSizeRefinement-module-scss-module__gqZVRq__showMore",
});
